module.exports = __webpack_public_path__ + "img/1.8efe5347.jpg";